/* Ninja AI background removal on the CLASSIC uploader (custom-uploader.js) — patches-ninja-ai, Owen 2026-10-29.

   custom-uploader.js writes the imgix `bg-remove=true` URL into _Upload from ~20 places, so instead of editing
   every writer this file works at the two edges, the same way the Ninja Transfers portal does:

   - PREVIEW: when the hero (#fileupload_hero, .viewer-box img) shows an imgix bg-remove render of a raster
     upload, Wil's Rank 1 job starts (np-ninja-bgr.js); once the saved cut-out is ready it is shown through
     `srcset`. `src` is left untouched, so every reader/toggle in custom-uploader.js keeps working on the imgix
     URL, and switching Remove Background off (src loses bg-remove) drops the srcset.
   - ADD TO CART: at submit, an imgix bg-remove _Upload / Upload / _cartImg value whose cut-out is ready is
     replaced by the cut-out (rect crop when the imgix URL trimmed, the native canvas when it did not), and the
     line records _BG Removal Service / _BG Removal Rank Choice / _Ninja AI Rank 1 Version. An add while the job
     is still running waits for it (90s cap, as on Ninja Transfers); failed = the imgix URL ships, as before.
     While the job runs the hero shows the original, not the old remover (np-ninja-bgr.js preview filter). _Original Image is never touched; vectors are never sent.

   Off wherever the 2.0 builder is mounted (#np-e2-artimg): np-emb2.js owns removal there. */
(function () {
  'use strict';
  if (window.__npNinjaClassic) return;
  window.__npNinjaClassic = true;
  var UPLOAD_HOST = /^https:\/\/(ninjauploads-production\.imgix\.net|ninja-services-production-ninjauploadss3bucket-[a-z0-9]+\.s3[a-z0-9.-]*\.amazonaws\.com)\//i;
  var PROPS = ['properties[_Upload]', 'properties[Upload]', 'properties[Upload (Vector Files Preferred)]', 'properties[_Upload (Vector Files Preferred)]', 'properties[_cartImg]'];
  var MARK = 'data-np-ninja-prop';

  function nj() { return window.NpNinjaBgr || null; }
  /* C547: the 2.0 builder owns removal in AI mode only — its Classic Order Mode (body.np-e2-classic) is the classic uploader,
     so the preview paint and the add-to-cart swap run there too (the preview filter otherwise left the original showing) */
  function builder() { return !!document.getElementById('np-e2-artimg') && !document.body.classList.contains('np-e2-classic'); }
  function removed(u) { return /[?&]bg-remove=true/.test(String(u || '')); }
  function source(u) {
    var b = String(u || '').split('?')[0];
    if (!UPLOAD_HOST.test(b)) return '';
    b = b.replace(/^https:\/\/[^/]+/, 'https://ninjauploads-production.imgix.net');
    return nj() && nj().raster(b) ? b : '';
  }
  /* the cut-out equivalent of an imgix bg-remove URL, or '' (kick = start the job if it is not running) */
  function cutFor(u, kick) {
    if (builder() || !removed(u)) return '';
    var s = source(u);
    if (!s) return '';
    var r = nj().peek(s);
    if (!r) { if (kick) nj().cutout(s).catch(function () {}); return ''; }
    var n = new URL(r.url);
    if (!/[?&]trim=/.test(u)) { ['rect', 'trim', 'trim-tol'].forEach(function (k) { n.searchParams.delete(k); }); n.searchParams.set('fm', 'png'); }
    var h = /[?&]h=(\d+)/.exec(u);
    if (h) { n.searchParams.set('h', h[1]); n.searchParams.set('auto', 'compress'); }
    return n.toString();
  }

  /* ---- preview ---- */
  function heroes() { return Array.prototype.slice.call(document.querySelectorAll('#fileupload_hero, .viewer-box img')); }
  function paint(img) {
    var cut = cutFor(img.getAttribute('src'), true);
    if (cut) { if (img.getAttribute('srcset') !== cut) img.setAttribute('srcset', cut); }
    else if (img.hasAttribute(MARK)) { img.removeAttribute('srcset'); img.removeAttribute(MARK); return; }
    if (cut) img.setAttribute(MARK, '1');
  }
  function paintAll() { heroes().forEach(paint); }
  var mo = new MutationObserver(function (list) {
    list.forEach(function (m) { if (m.type === 'attributes' && m.target.tagName === 'IMG') paint(m.target); });
  });
  function watch() {
    heroes().forEach(function (img) {
      if (img.__npNinjaWatched) return;
      img.__npNinjaWatched = true;
      mo.observe(img, { attributes: true, attributeFilter: ['src'] });
      paint(img);
    });
  }
  document.addEventListener('np-ninja-bgr:ready', function () { watch(); paintAll(); });
  document.addEventListener('DOMContentLoaded', watch);
  new MutationObserver(watch).observe(document.documentElement, { childList: true, subtree: true });

  /* ---- add to cart ---- */
  function setHidden(form, name, value) {
    var sel = 'input[' + MARK + '][name="properties[' + name + ']"]';
    var el = form.querySelector(sel);
    if (!value) { if (el) el.parentNode.removeChild(el); return; }
    if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.name = 'properties[' + name + ']'; el.setAttribute(MARK, '1'); form.appendChild(el); }
    el.value = value;
  }
  document.addEventListener('submit', function (e) {
    try {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]') || builder() || !nj()) return;
      /* Rank 1 still running for this design: hold the add once (capped at 90s, as on Ninja Transfers) so an
         early click never ships the old remover, then submit again with the cut-out (or imgix if it failed) */
      if (!form.__npNinjaHeld) {
        var running = [];
        PROPS.forEach(function (name) {
          Array.prototype.slice.call(form.querySelectorAll('[name="' + name + '"]')).forEach(function (el) {
            if (!el.disabled && removed(el.value) && source(el.value) && nj().state(el.value) === 'pending') running.push(nj().settled(el.value, 90000));
          });
        });
        if (running.length) {
          e.preventDefault(); e.stopImmediatePropagation();
          var btn = e.submitter || form.querySelector('[type="submit"]');
          if (btn) btn.classList.add('working');
          Promise.all(running).then(function () {
            if (btn) btn.classList.remove('working');
            form.__npNinjaHeld = true;
            try { form.requestSubmit(btn && btn.form === form ? btn : undefined); } finally { form.__npNinjaHeld = false; }
          });
          return;
        }
      }
      var hit = null, cartCut = null;
      PROPS.forEach(function (name) {
        Array.prototype.slice.call(form.querySelectorAll('[name="' + name + '"]')).forEach(function (el) {
          if (el.disabled) return;
          var cut = cutFor(el.value, false);
          if (!cut) return;
          /* some classic templates keep _Upload raw and only remove on _cartImg: either one records the cut-out */
          if (!hit || name !== 'properties[_cartImg]') hit = nj().peek(source(el.value));
          if (name === 'properties[_cartImg]') cartCut = { src: source(el.value), url: cutFor(el.value.replace(/([?&])h=\d+(&|$)/, '$1').replace(/[?&]$/, ''), false) };
          el.value = cut;
        });
      });
      /* C547 (Justin 2026-11-03: "Owen puts the cut-out into _Upload, which is what the patch product pages already do. this
         makes sense"): where _Upload stays the RAW file and only _cartImg carried bg-remove (custom-magnets and the patch PDPs'
         Classic mode), the print file becomes the full-size cut-out of that same upload — production prints what the customer
         saw. No cut-out (job failed / not raster) = _Upload stays raw, exactly as today. */
      if (cartCut && cartCut.src && cartCut.url) {
        PROPS.forEach(function (name) {
          if (name === 'properties[_cartImg]') return;
          Array.prototype.slice.call(form.querySelectorAll('[name="' + name + '"]')).forEach(function (el) {
            if (el.disabled || removed(el.value) || source(el.value) !== cartCut.src) return;
            el.value = cartCut.url;
          });
        });
      }
      /* C552: a print file that is ALREADY the cut-out (Classic with unlocked proportions builds its stretched _Upload from the
         cut-out the preview shows) records the same three properties — found through the line's raw upload */
      if (!hit) {
        var origEl = form.querySelector('[name="properties[_Original Image]"]'), orig = origEl ? source(origEl.value) : '';
        var r552 = orig ? nj().peek(orig) : null;
        if (r552) PROPS.forEach(function (name) { Array.prototype.slice.call(form.querySelectorAll('[name="' + name + '"]')).forEach(function (el) { if (!el.disabled && !hit && nj().isNinja(el.value) && String(el.value).split('?')[0] === String(r552.url).split('?')[0]) hit = r552; }); });
      }
      setHidden(form, '_BG Removal Service', hit ? hit.service : '');
      setHidden(form, '_BG Removal Rank Choice', hit ? 'Rank 1' : '');
      setHidden(form, '_Ninja AI Rank 1 Version', hit ? hit.url : '');
    } catch (eS) { /* never block an add */ }
  }, true);
})();
